var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEater(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.347 16.943a6.471 6.471 0 116.479-6.471 6.479 6.479 0 01-6.48 6.47zm0-11.67a5.2 5.2 0 10.015 10.4 5.2 5.2 0 00-.015-10.4zM2.428 5.306a.312.312 0 00-.303.311v1.574a.23.23 0 01-.458 0V5.567a.261.261 0 00-.259-.261.261.261 0 00-.261.26v1.625a.228.228 0 11-.455 0V5.615a.306.306 0 00-.613-.012l-.078 2.44A1.124 1.124 0 00.83 9.165c.09.028.15.113.146.208l-.183 6.249v.036a.599.599 0 00.717.562.62.62 0 00.511-.64l-.18-6.218a.203.203 0 01.146-.206 1.125 1.125 0 00.843-1.123l-.064-2.436a.312.312 0 00-.318-.304l-.02.012zM19.99 5.521a.239.239 0 00-.211-.227h-.028c-1.498 0-1.624 3.844-1.624 3.844-.062 1.615.303 2.135.716 2.27a.312.312 0 01.211.312l-.281 3.908v.04a.604.604 0 00.815.562.593.593 0 00.385-.562v-5.03l.017-2.57c0-.846.022-1.698 0-2.546z",
    fill: "#252D48"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.968 11.048l-.3.109c-.208-.573-.544-1.612-.063-2.095.377-.377 1.023-.31 1.356.094l-.246.203c-.211-.258-.642-.314-.884-.072-.348.348-.017 1.339.137 1.761zm2.111-3.066c-.104.199-.277.335-.545.408-.07-.268-.039-.486.082-.676.12-.19.33-.362.616-.532-.004.333-.049.601-.153.8zm1.935 1.76c0-.901-.766-1.6-1.662-1.512.293-.47.246-1.11.222-1.641-.447.232-.981.492-1.26.925a4.6 4.6 0 00-.3-.706l-.412.196c.24.443.467.935.562 1.483-1.027-.656-2.398-.007-2.398 1.255.002.772.375 1.985.805 2.624.278.412.627.694 1.051.694.244 0 .544-.13.768-.204.229.076.522.204.77.203.422-.002.772-.285 1.05-.697.433-.642.804-1.843.804-2.62z",
    fill: "#252D48"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEater);
export default __webpack_public_path__ + "static/media/eater.095be35a136662622004d0406b958b61.svg";
export { ForwardRef as ReactComponent };